import Column from '@components/Column';
import Text from '@components/Text';
import { Fragment } from 'react';

import useMainRecommendedItems from './hooks/useMainRecommendedItems';
import RecommendationItem from './RecommendationItem';
import styles from './styles.module.scss';

function Recommendation() {
  const data = useMainRecommendedItems();
  if (!data || data.items.length === 0) {
    return (<Fragment/>);
  }
  return (
        <Column as='section'
                className={styles.container} >
            <div className={styles.wrapper}>
                <Text size='xl' fontWeight='bold'>{data?.title}</Text>
            </div>
            <div className={styles.contents}>
                {data?.items.map((item) => (
                    <RecommendationItem item={item}
                                        key={item.itemId} />
                ))}
            </div>
        </Column>
  );
}

export default Recommendation;
